import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Spinner } from 'react-bootstrap';

import { useWarehouseContext } from 'providers/WarehouseProvider';

import Table from 'components/common/Table';

import { putAwayApi, grnApi } from 'api';

import paths from 'routes/paths';
import { CREATE_PUT_AWAY_LIST_COLUMNS } from 'constants/putAway';

const CreatePutaway = () => {
  const navigate = useNavigate();

  const { loading, selectedWarehouse } = useWarehouseContext();

  const handleCreatePutaway = useCallback(
    async selectedRows => {
      const grnIds = selectedRows.map(row => row.id);

      const response = await putAwayApi.create({
        grn_ids: grnIds,
      });

      return {
        result: response,
        shouldRefetch: false,
      };
    },
    [selectedWarehouse],
  );

  const bulkActions = [
    {
      value: 'create_putaway',
      label: 'Create Putaway',
      variant: 'primary',
      successMessage: 'Successfully create putaway',
      errorMessage: 'Fail to create putaway',
      handler: handleCreatePutaway,
      onSuccess: response => {
        if (response?.result?.id !== null) {
          navigate(`${paths.putAwayDetails(response.result.id)}`);
        }
      },
    },
  ];

  if (loading || !selectedWarehouse) {
    return (
      <Card className="d-flex justify-content-center align-items-center p-4">
        <Spinner animation="border" variant="primary" />
      </Card>
    );
  }

  return (
    <Table
      title="Create Putaway"
      apiService={grnApi}
      sortable={false}
      columns={CREATE_PUT_AWAY_LIST_COLUMNS}
      bulkActions={bulkActions}
      fetchConfig={{
        method: 'getGRNPutaway',
      }}
      resourceId={selectedWarehouse?.id}
      enablePagination={false}
    />
  );
};

export default CreatePutaway;
